import { render } from "./OpinionCard.vue?vue&type=template&id=5e857672&scoped=true"
import script from "./OpinionCard.vue?vue&type=script&lang=js"
export * from "./OpinionCard.vue?vue&type=script&lang=js"

import "./OpinionCard.vue?vue&type=style&index=0&id=5e857672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e857672"]])

export default __exports__